const accordionBtns = document.querySelectorAll('[data-content="accordion"]');
accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    accordionBtns.forEach((accord) => {
      if (accord !== this) {
        accord.classList.remove("is-open");
        let otherContent = accord.nextElementSibling;
        otherContent.style.maxHeight = null;
        otherContent.style.display = 'none';
      }
    });
    this.classList.toggle("is-open");
    let content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.display = 'none';
    } else {
      content.style.display = 'block';
      content.style.maxHeight = "100%";
    }
  };
});
